<div *ngIf="!isServer" class="tele-cmi-disabled">
  <cpds-alert [intent]="alertIntent.INFO">
    The remaining questions in this section will be completed during
    {{ isAdvisor ? 'the Tele-CMI' : 'a phone interview' }}.
    <div>
      <a class="tele-cmi-disabled__action-link" (click)="navigateToNextSection()" target="_blank">
        Continue to the next section
      </a>
    </div>
  </cpds-alert>
</div>
